import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { notificationLog } from '../../data/notificationLog';
import { notificationSchedules } from '../../data/notificationSchedules';

const { FiBell, FiMail, FiCheckCircle, FiAlertTriangle, FiTrendingUp, FiClock } = FiIcons;

const MetricCard = ({ label, value, sub, icon, border, iconColor, valueColor, index }) => (
  <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.07 }}
    className={`bg-white rounded-xl border ${border} shadow-sm p-5 flex flex-col gap-3`}>
    <div className="flex items-center justify-between">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</span>
      <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${iconColor}`}>
        <SafeIcon icon={icon} className="text-lg" />
      </div>
    </div>
    <div className={`text-3xl font-bold ${valueColor || 'text-slate-800'}`}>{value}</div>
    {sub && <p className="text-xs text-slate-400 font-medium">{sub}</p>}
  </motion.div>
);

const NotificationMetrics = () => {
  const total = notificationLog.length;
  const delivered = notificationLog.filter(n => n.status === 'Delivered').length;
  const failed = notificationLog.filter(n => n.status === 'Failed').length;
  const opened = notificationLog.filter(n => n.opened).length;
  const clicked = notificationLog.filter(n => n.clicked).length;
  const activeSchedules = notificationSchedules.filter(s => s.isActive).length;
  const openRate = total ? Math.round((opened / delivered) * 100) : 0;

  const cards = [
    { label: 'Total Sent', value: total, sub: 'All notifications dispatched', icon: FiBell, border: 'border-blue-100', iconColor: 'bg-blue-50 text-blue-600' },
    { label: 'Delivered', value: delivered, sub: `${Math.round(delivered / total * 100)}% delivery rate`, icon: FiMail, border: 'border-emerald-100', iconColor: 'bg-emerald-50 text-emerald-600', valueColor: 'text-emerald-600' },
    { label: 'Failed', value: failed, sub: 'Check email configuration', icon: FiAlertTriangle, border: 'border-red-100', iconColor: 'bg-red-50 text-red-600', valueColor: failed > 0 ? 'text-red-600' : 'text-slate-800' },
    { label: 'Open Rate', value: `${openRate}%`, sub: `${opened} of ${delivered} opened`, icon: FiCheckCircle, border: 'border-violet-100', iconColor: 'bg-violet-50 text-violet-600' },
    { label: 'Click-Through', value: `${total ? Math.round(clicked / delivered * 100) : 0}%`, sub: `${clicked} clicked through`, icon: FiTrendingUp, border: 'border-amber-100', iconColor: 'bg-amber-50 text-amber-600' },
    { label: 'Active Schedules', value: activeSchedules, sub: `of ${notificationSchedules.length} total`, icon: FiClock, border: 'border-teal-100', iconColor: 'bg-teal-50 text-teal-600' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((c, i) => <MetricCard key={c.label} {...c} index={i} />)}
    </div>
  );
};

export default NotificationMetrics;